import { AxiosResponse } from 'axios'
import { api } from '@services/api'

export interface Newscast {
  id: number
  title: string
  description: string
  url: string
  image?: {
    imagesId: number
    description: string
    alt: string
    path: string
  }
  createdAt: string
  updatedAt: string
}

interface indexParams {
  size?: number
}

export default {
  index: async (query?: indexParams): Promise<AxiosResponse<Newscast[]>> => {
    const params = new URLSearchParams()

    if (query) {
      Object.entries(query).map(([key, value]) => params.append(key, value))
    }
    return api.get('/newscasts', { params })
  }
}
